import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { searchStyle } from "../../lib/styles/styleLibrary";
import searchLogo from "../../assets/svg/search.svg";
import Auth from "../../lib/middleware/auth";
import { SearchInput, SearchWrapper } from "./component";
import { isEmpty } from "../../lib/helpers/helpers";
import { useSearchWedding } from "../../redux/api/WeddingAPI";
import { useLocation } from "react-router-dom";

const SearchComponent = ({
	placeholderText,
	setQueryResult = () => {
		return null;
	},
	setLoading = () => {
		return null;
	},
	setSearchText = () => {
		return null;
	},
}) => {
	const experience = Auth.getExperience();
	const location = useLocation();

	const [searchQuery, setSearchQuery] = useState("");
	const [search, setSearch] = useState(false);
	const { data: searchDt, isLoading } = useSearchWedding({
		searchQuery,
		location,
		search,
	});
	useEffect(() => {
		setLoading(isLoading);
		// setSearchText("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	useEffect(() => {
		setSearchText(searchQuery);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search]);

	useEffect(() => {
		if (isEmpty(searchDt)) {
			return;
		}
		const { hasError } = searchDt;
		if (hasError) {
			return;
		}
		setQueryResult(searchDt.data);
		search && setSearch(false);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchDt, search]);

	return (
		<SearchWrapper tw="m-4">
			<SearchInput
				placeholder={
					placeholderText
						? placeholderText
						: experience === "guest"
						? "Join a wedding with event code"
						: "Join a wedding"
				}
				enterButton="Search"
				size="middle"
				css={searchStyle}
				value={searchQuery}
				onChange={(e) => {
					setSearchQuery(e.target.value);
				}}
				loading={isLoading}
				prefix={<img src={searchLogo} alt="" tw="pr-2" />}
				onSearch={() => {
					!search && setSearch(true);
					setSearchText(searchQuery);
				}}
			/>
		</SearchWrapper>
	);
};

export default SearchComponent;
